var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCcKlarna = function SvgCcKlarna(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 35 24"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 23,
    x: 0.5,
    y: 0.5,
    fill: "#FEB4C7",
    stroke: "#D9D9D9",
    rx: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#17120F",
    fillRule: "evenodd",
    d: "M5.424 15.38H4V9h1.424v6.38ZM8.98 9H7.586a3.698 3.698 0 0 1-1.44 2.957l-.552.425 2.139 2.998H9.49l-1.968-2.76A5.148 5.148 0 0 0 8.98 9Zm2.271 6.378H9.906V9h1.345v6.377Zm4.064-4.411v.282a2.209 2.209 0 0 0-1.274-.404c-1.25 0-2.264 1.042-2.264 2.327 0 1.286 1.014 2.328 2.264 2.328.473 0 .91-.15 1.274-.404v.282h1.284v-4.411h-1.284Zm-.004 2.206c0 .626-.521 1.134-1.164 1.134-.643 0-1.164-.508-1.164-1.134 0-.627.521-1.135 1.164-1.135.643 0 1.164.508 1.164 1.135Zm13.556-1.924v-.282h1.285v4.41h-1.285v-.281a2.21 2.21 0 0 1-1.273.404c-1.25 0-2.264-1.042-2.264-2.328 0-1.285 1.013-2.327 2.264-2.327.472 0 .91.15 1.273.404ZM27.7 14.307c.643 0 1.164-.508 1.164-1.134 0-.627-.521-1.135-1.164-1.135-.643 0-1.164.508-1.164 1.135 0 .626.521 1.134 1.164 1.134Zm-4.652-3.459c-.513 0-.999.164-1.323.616v-.497h-1.28v4.411h1.295V13.06c0-.67.438-1 .964-1 .565 0 .89.348.89.99v2.328h1.283v-2.805c0-1.027-.794-1.725-1.829-1.725Zm-4.46.119v.574c.257-.344.737-.574 1.259-.574v1.284h-.016c-.508 0-1.24.373-1.24 1.067v2.06H17.27v-4.411h1.316Zm12.122 3.675c0-.458.361-.829.806-.829.445 0 .806.371.806.829 0 .458-.36.829-.806.829a.818.818 0 0 1-.806-.829Z",
    clipRule: "evenodd"
  })));
};
export default SvgCcKlarna;